// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel-module--root--pCiQ6","inner":"carousel-module--inner--3PEBK"};